import React from 'react';

import PageTitle from '../../shared-components/page-title/PageTitle';

import AlertList from './components/AlertsList';

/**
 *  function component
 */
function Alerts() {

  return (
    <div>
      <div>
        <PageTitle title="Alerts" />
      </div>
      {/* Content based on tab */}
      <div className="content">
        <AlertList />
      </div>
    </div>
  );
}

export default Alerts;
